import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { selectListItems } from "../../../../../../../redux/library/selector";
import { selectReturnRequestsListItems } from "../../../../../../../redux/return-requests/selector";
import { returnRequests } from "../../../../../../../redux/return-requests/action";
import PageLoader from "../../../../../../../components/PageLoader";
import Table from "../../../../../../../common/components/table";


const DBAReturnRequests = ({ selectedDba }: any) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectReturnRequestsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.OrderNumber', headerName: 'Order Number', searchField: 'Message.OrderNumber', sortable: true, filter: true, filterType: 'text' },
      { field: 'Message.Quantity', headerName: 'Quantity' },
      { field: 'Message.ReturnRequestNumber', headerName: 'Return Request Number', sortable: true },
      {
        field: 'Message.ReturnRequestStatusId',
        headerName: 'Return Request Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ReturnRequestStatus },
        isRowColorDecider: true,
        sortable: true,
        filter: false,
        isReturnRequestEditble: true
      },
      { field: 'Message.ReturnRequestDate', headerName: 'Return Request Date / Time', isDateValueFormat: true, sortable: true, filter: false },
      { field: 'Message.RefundedAmount', headerName: 'Refunded Amount', isCurrencyValueFormat: true, },
      { field: 'Message.ReturnRequestTotal', headerName: 'Return Request Total', isCurrencyValueFormat: true, },
      { field: 'Message.CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'Message.ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
    ]);
  }

  const fetchReturnRequestsList = () => {
    dispatch(returnRequests.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/return-requests/list`,
      entity: 'returnRequests',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc"
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchReturnRequestsList()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(returnRequests.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/return-requests/delete`,
      entity: 'returnRequests',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: data?.Message?.Id,
            }
          }
        ]
      }
    })).then(() => {
      fetchReturnRequestsList()
    });
  }
  const handleEdit = (data: any) => {
    navigate(`/management/dbn-cloud/dbas/${selectedDba?.DBAId}/return-requests/${data?.Id}`)
  }
  const handleReloadData = () => {
    fetchReturnRequestsList()
  }
  const additionButtons: any = [
    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Message.OrderNumber",
        FieldText: "Message.OrderNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } 
    dispatch(returnRequests.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/return-requests/list`,
      entity: 'returnRequests',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleReturnRequestStatusClick = async (event: any, dataId: any) => {
    await dispatch(returnRequests.resetAction({ actionType: 'update' }))
    await dispatch(returnRequests.update({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dom/dbn/orders/status`,
      entity: 'returnRequests',
      jsonData: {
       
            Context: {},
           Records: [
          {
              ReturnRequestId: dataId?.Message?.Id,
              ReturnRequestStatusId: event
            }
        ]
      }
    })).then(() => {
      dispatch(returnRequests.list({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/return-requests/list`,
        entity: 'returnRequests',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

 

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
        additionButtons={additionButtons} enableFilter={true} onSearch={handleSearch}  paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete}
          onReturnRequestStatusClick={handleReturnRequestStatusClick} headingName="DBA Orders- Return Requests" />
      }
    </>
  );
};

export default DBAReturnRequests;


